'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

exports.default = function (Component) {
  var ShareInputDecorator = function (_React$Component) {
    _inherits(ShareInputDecorator, _React$Component);

    function ShareInputDecorator() {
      var _ref;

      _classCallCheck(this, ShareInputDecorator);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      var _this = _possibleConstructorReturn(this, (_ref = ShareInputDecorator.__proto__ || Object.getPrototypeOf(ShareInputDecorator)).call.apply(_ref, [this].concat(args)));

      _this._defaultInputRef = { current: null };
      _this.focus = _this.focus.bind(_this);
      _this.select = _this.select.bind(_this);
      _this.refCallback = _this.refCallback.bind(_this);
      return _this;
    }

    _createClass(ShareInputDecorator, [{
      key: 'focus',
      value: function focus() {
        if (this._ref && typeof this._ref.focus === 'function') {
          this._ref.focus();
          return;
        }

        var inputRef = this.props.inputRef || this._defaultInputRef;
        if (inputRef.current && typeof inputRef.current.focus === 'function') {
          inputRef.current.focus();
        }
      }
    }, {
      key: 'select',
      value: function select() {
        if (this._ref && typeof this._ref.select === 'function') {
          this._ref.select();
          return;
        }

        var inputRef = this.props.inputRef || this._defaultInputRef;
        if (inputRef.current && typeof inputRef.current.select === 'function') {
          inputRef.current.select();
        }
      }
    }, {
      key: 'refCallback',
      value: function refCallback(ref) {
        if ((0, _utils.isFunctionalComponent)(Component)) return;
        this._ref = ref;
        if (ref) (0, _utils.copyMethods)(ref, this);
      }
    }, {
      key: 'render',
      value: function render() {
        var _props = this.props,
            inputRef = _props.inputRef,
            rest = _objectWithoutProperties(_props, ['inputRef']);

        return _react2.default.createElement(Component, _extends({}, rest, {
          inputRef: inputRef || this._defaultInputRef,
          ref: this.refCallback
        }));
      }
    }]);

    return ShareInputDecorator;
  }(_react2.default.Component);

  var componentName = (0, _getComponentName2.default)(Component);
  ShareInputDecorator.displayName = 'ShareInput(' + componentName + ')';
  ShareInputDecorator.propTypes = _extends({}, Component.propTypes, {
    inputRef: _refObject2.default
  });
  ShareInputDecorator.defaultProps = Component.defaultProps;
  (0, _utils.attachWrappedComponent)(ShareInputDecorator, Component);

  return ShareInputDecorator;
};

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _getComponentName = require('react-utils/getComponentName');

var _getComponentName2 = _interopRequireDefault(_getComponentName);

var _utils = require('./utils');

var _refObject = require('../utils/propTypes/refObject');

var _refObject2 = _interopRequireDefault(_refObject);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.2750/js/decorators/ShareInput.js
// module id = 125
// module chunks = 171